import axios from 'axios'
import Cookies from 'js-cookie'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

axiosInstance.interceptors.request.use(
  config => {
    config.headers['Authorization'] = `Bearer ${Cookies.get('authentication')}`
    return config
  },
  error => Promise.reject(error)
)

export default axiosInstance
